import script from "./OperationsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsDashboard.vue?vue&type=script&setup=true&lang=js"

import "./OperationsDashboard.vue?vue&type=style&index=0&id=4e31cdc4&lang=scss&scoped=true"
import "./OperationsDashboard.vue?vue&type=style&index=1&id=4e31cdc4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e31cdc4"]])

export default __exports__